import { z } from 'zod';

export const roleSchema = z.object({
  name: z.string().min(2, 'Naziv je obavezan (minimum 2 karaktera)'),
  description: z.string().optional(),
  sortOrder: z.number().int().min(0).optional(),
  canAssignEquipment: z.boolean().optional(),
});

export type RoleFormData = z.infer<typeof roleSchema>;
